export const MAX_TRADING_DAYS = 5;
export const CONSISTENCY_RULE_WARNING = 70;
export const CONSISTENCY_RULE_DANGER = 50;
